import { query, where, getDocs } from 'firebase/firestore'
import { collection } from 'firebase-client/client'

export const getPoolPredictions = async (poolId) => {
  const q = query(collection("predictions"), where("poolId", "==", poolId))
  const querySnapshot = await getDocs(q)
  return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
}
